<div class="form-floating-icon">
  @if (state === 'submit') {
    <mwe-button-link
      [isDisabled]="disabled"
      color="blue"
      [dataTest]="'form-input-' + inputElem.name + '-submit'"
      [label]="submitLabel"
      (clicked)="submit()"
    />
  }
  @if (state === 'loading') {
    <div class="loading-spinner"></div>
  }
</div>
